import { TaxLinkInfo } from 'components/forms/TaxSearches/NJTaxSearch/types';
import { TrashCanIcon } from 'components/ui/icons';
import TextField from 'components/ui/TextField';
import React from 'react';

interface PropTypes {
  idx: number;
  linkInfo: TaxLinkInfo;
  handleDelete: (indexToRemove: number, id: number) => void;
  handleInfoChange: (event: React.ChangeEvent<HTMLInputElement>, label: string, index: number) => void;
}

export const NjTaxLink = (props: PropTypes) => {
  return (
    <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
      <TextField
        placeholder="URL"
        value={props.linkInfo.link}
        onChange={e => props.handleInfoChange(e, 'link', props.idx)}
        width="425px"
      />
      <TextField
        placeholder="Title"
        value={props.linkInfo.title}
        onChange={e => props.handleInfoChange(e, 'title', props.idx)}
        width="175px"
      />
      <div
        style={{ marginTop: 14, cursor: 'pointer', zIndex: 50 }}
        onClick={() => props.handleDelete(props.idx, props.linkInfo.id)}
      >
        <TrashCanIcon />
      </div>
    </div>
  );
};
